const resumeState = {
    resume:[],

}



export const resumeReducer = (state=resumeState,action) =>{
    const {payload,type} = action;
    
    if(type === "RESUME_GET_SUCCESS"){
        return{
            ...state,
            resume: payload
        }
    }
    return state;
}